/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Carriers API
 * Carrier-facing API for the carrier portal (carriers.freightsimple.com).  Authentication: a carrier opens a permanent signed login link, exchanges it for a session token, and presents that token as a bearer on every other call. `CarrierPortalAuthenticationFilter` validates the session and scopes each request to one carrier. Operations use `security: []` (no Micronaut JWT) — the filter is the authenticator, the same model the agents API uses.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { InvoiceAudit } from "./InvoiceAudit";
import {
  InvoiceAuditFromJSON,
  InvoiceAuditFromJSONTyped,
  InvoiceAuditToJSON,
  InvoiceAuditToJSONTyped,
} from "./InvoiceAudit";

/**
 *
 * @export
 * @interface InvoiceAuditsResponse
 */
export interface InvoiceAuditsResponse {
  /**
   *
   * @type {Array<InvoiceAudit>}
   * @memberof InvoiceAuditsResponse
   */
  audits: Array<InvoiceAudit>;
}

/**
 * Check if a given object implements the InvoiceAuditsResponse interface.
 */
export function instanceOfInvoiceAuditsResponse(
  value: object,
): value is InvoiceAuditsResponse {
  if (!("audits" in value) || value["audits"] === undefined) return false;
  return true;
}

export function InvoiceAuditsResponseFromJSON(
  json: any,
): InvoiceAuditsResponse {
  return InvoiceAuditsResponseFromJSONTyped(json, false);
}

export function InvoiceAuditsResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): InvoiceAuditsResponse {
  if (json == null) {
    return json;
  }
  return {
    audits: (json["audits"] as Array<any>).map(InvoiceAuditFromJSON),
  };
}

export function InvoiceAuditsResponseToJSON(json: any): InvoiceAuditsResponse {
  return InvoiceAuditsResponseToJSONTyped(json, false);
}

export function InvoiceAuditsResponseToJSONTyped(
  value?: InvoiceAuditsResponse | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    audits: (value["audits"] as Array<any>).map(InvoiceAuditToJSON),
  };
}
